import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({
  providedIn: "root",
})
export class PlayerWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    selected_code: number,
    match_code: string,
    victory: boolean | null,
    satisfaction: number | null,
    token: string
  ): Observable<void> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.post)
      .setUrl(ApiUrls.IDENTIFY_PLAYER_ENDPOINT())
      .setAuthorization(new TokenAuthorization(token))
      .setBody({
        selected_code: selected_code,
        match_code: match_code,
        victory: victory ? 1 : victory === false ? 0 : null,
        satisfaction: satisfaction,
      })
      .build();
    return this.baseHandler.execute(parameters);
  }
}
